import React, { useState, useEffect } from 'react';
//import Button from 'olive-react-myoneui/lib/Button';
//import SampleImage2 from '../../../assets/images/sample2.jpg';
import Rate from '../../../components/Rate';
import IconDesc from '../my-course/IconDesc';
import { bookIcon, boxOIcon, checkCircleIcon } from '../../../constants/icons';
import Container from 'olive-react-myoneui/lib/Container';
import Row from 'olive-react-myoneui/lib/Row';
import Col from 'olive-react-myoneui/lib/Col';
import { useSelector } from 'react-redux';

function CourseDetailsHeader({ className, coursedetails }) {
  const bannerColour = useSelector(
    (state) => state.user.website.header.top_nav.background_color
  );
  const [rating, setRating] = useState(coursedetails?.bundle.total_ratting);
  const [rate, setRate] = useState(0);

  const [tutor, setTutor] = useState('');

  const tutorfn = (tutor) => {
    let tutorlist = [];
    if (tutor && tutor.length > 0) {
      tutorlist = tutor && tutor.map((lang) => lang.us_name);
    }
    let listtutortring = tutorlist && tutorlist.toString();
    return listtutortring;
  };

  useEffect(() => {
    setRating(coursedetails?.bundle.ratting);
  }, [coursedetails]);
  // console.log(coursedetails, 'total_ratting');
  var myRatings = coursedetails?.bundle.total_ratting;
  // console.log(myRatings,"myRatings")

  const round = (args) => {
    return Math.round(args)
  }


  return (
    <div className={`${className || ''} course-inner-header`}>
      <Container>
        <Row className="align-items-center">
          <Col lg={8}>
            <div className="course-description">
              <h1>{coursedetails?.bundle?.c_title}</h1>
              <p className="mb-1">
                {coursedetails?.bundle?.c_short_description}
              </p>
              {coursedetails?.bundle.c_rating_enabled === '1' &&
                myRatings > 0 && (
                  <div className="rating-wrapper d-flex align-items-center gap-1 mt-3">
                     <div className="start-wrap">
                      <p className="mb-0">{round(myRatings)}</p>
                      <Rate
                        rating={myRatings}
                        count={1}
                        onRating={(rate) => setRate(rate)}
                        /* onRating={(rate) => setRating(rate)}*/
                      />
                    </div>
                  </div>
                )}
              <div className="rating-wrapper d-block d-md-flex align-items-center gap-3 mb-3 mt-3">
                <IconDesc
                  icon={bookIcon}
                  paraDesc="Instructed by"
                  linkDesc={`${coursedetails?.instructors || ''}`}
                  className="mb-1 mb-md-0"
                />
                <IconDesc
                  icon={checkCircleIcon}
                  paraDesc={`${coursedetails?.expireson || ''}`}
                  className="mb-1 mb-md-0"
                />
                <IconDesc
                  icon={boxOIcon}
                  paraDesc={`${coursedetails?.course_count || 0} Courses`}
                  className="mb-1 mb-md-0 "
                />
                <IconDesc
                  icon={boxOIcon}
                  paraDesc={`${coursedetails?.training_courses_count || 0} Training Courses`}
                  className="mb-1 mb-md-0 "
                />
                <IconDesc
                  icon={boxOIcon}
                  paraDesc={`${coursedetails?.training_events_count || 0} Training Events`}
                  className="mb-1 mb-md-0 "
                />
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default CourseDetailsHeader;
